import { formatDistanceToNow } from "date-fns";

export function relativeTime(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return formatDistanceToNow(date, { addSuffix: true });
}

export function getMetadataString(
  metadata: Record<string, unknown> | null | undefined,
  key: string,
): string | null {
  const value = metadata?.[key];
  return typeof value === "string" && value.trim() ? value.trim() : null;
}

export function actorNameFromTitle(title: string): string | null {
  const match = title.match(
    /^(.+?)\s+(mentioned|replied|assigned|commented|shared|invited|added|updated)\b/i,
  );
  return match?.[1]?.trim() || null;
}

/** Person initials — first letter of the first two words ("John Doe" → "JD").
 *  Not the connector monogram `initialsFor` in `ats-sync/lib/initials.ts`
 *  (first two letters of one name) — same name, different output by design
 *  (ARBI-851). */
export function initialsFor(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("");
}
